import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume20 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="flex flex-wrap w-full mx-auto bg-white shadow-lg p-5 box-border" ref={resumeRef}>
        <div className="w-full bg-[#a7386a] text-white p-5 text-center box-border">
          <h1 className="text-4xl font-bold">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</h1>
          <p className="mt-2">{ResumeStore?.resumeBuilder.personalDetails.email} | {ResumeStore?.resumeBuilder.personalDetails.phone} | {ResumeStore?.resumeBuilder.personalDetails.city}, {ResumeStore?.resumeBuilder.personalDetails.country} | {ResumeStore?.resumeBuilder.websites[0]?.link}</p>
        </div>
        <div className="w-1/3 p-5 bg-[#333] text-white box-border">
          <div className="mb-5">
            <h2 className="text-xl font-bold border-b-2 border-[#a7386a] pb-2 mb-2">HARD SKILLS</h2>
            <ul className="list-disc pl-5">
              {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                <li key={index} className="mb-2">{skill}</li>
              ))}
            </ul>
          </div>
          <div className="mb-5">
            <h2 className="text-xl font-bold border-b-2 border-[#a7386a] pb-2 mb-2">SOFT SKILLS</h2>
            <ul className="list-disc pl-5">
              {ResumeStore?.resumeBuilder.hobbies.map((hobby, index) => (
                <li key={index} className="mb-2">{hobby}</li>
              ))}
            </ul>
          </div>
          <div className="mb-5">
            <h2 className="text-xl font-bold border-b-2 border-[#a7386a] pb-2 mb-2">LANGUAGES</h2>
            <ul className="list-disc pl-5">
              {ResumeStore?.resumeBuilder.languages.map((languages, index) => (
                <li key={index} className="mb-2">{languages.language}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="w-2/3 p-5 box-border">
          <div className="mb-5">
            <h2 className="text-xl font-bold text-[#a7386a] border-b-2 border-[#a7386a] pb-2 mb-2">SUMMARY</h2>
            <p>{ResumeStore?.resumeBuilder.profileSummary}</p>
          </div>
          <div className="mb-5">
            <h2 className="text-xl font-bold text-[#a7386a] border-b-2 border-[#a7386a] pb-2 mb-2">WORK EXPERIENCE</h2>
            {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-lg font-medium">{job.jobTitle}</h3>
                <p>{job.company}, {job.city} | {job.startDate} - {job.endDate}</p>
                <ul className="list-disc pl-5 mt-2">
                  {job.description?.split('. ').map((desc, index) => (
                    <li key={index} className="mb-2">{desc}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mb-5">
            <h2 className="text-xl font-bold text-[#a7386a] border-b-2 border-[#a7386a] pb-2 mb-2">EDUCATION</h2>
            {ResumeStore?.resumeBuilder.education.map((edu, index) => (
              <div key={index} className="mb-4">
                <p><strong>{edu.degree}</strong><br />{edu.school}, {edu.city} | {edu.startDate} - {edu.endDate}</p>
                <p>Relevant Coursework: {edu.description}</p>
              </div>
            ))}
          </div>
          <div className="mb-5">
            <h2 className="text-xl font-bold text-[#a7386a] border-b-2 border-[#a7386a] pb-2 mb-2">CERTIFICATES</h2>
            {ResumeStore?.resumeBuilder.courses.map((edu, index) => (
              <div key={index} className="mb-4">
                <p><strong>{edu.course}</strong><br />{edu.institution}, | {edu.startDate} - {edu.endDate}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  ));
}

export default Resume20;
